
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/marketplace/amocrm",
      function () {
        return require("private-next-pages/[locale]/marketplace/amocrm.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/marketplace/amocrm"])
      });
    }
  